
import css from 'styled-jsx/css';

export default css`.webinar-series-hero {
  display: grid;
  grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
  justify-content: center;

  img {
    max-width: 100%;
  }

  &__wrapper {
    grid-column: content;
    display: grid;
    grid-gap: 20px;
    grid-template-columns: [content] 1fr [image] 1fr;
    align-items: center;
    max-width: $container-max-width;
    margin: 0 auto;
  }

  &__content {
    grid-column: content / span 2;
    text-align: center;

    @include media-query(desktop) {
      grid-column: content;
      text-align: left;
    }
  }

  &__asset-container {
    position: relative;
    padding: 1.5625rem;
    grid-column: content / span 2;
    text-align: center;

    @include media-query(desktop) {
      grid-column: image;
      text-align: left;

      img {
        border-radius: 25px;
      }
    }
  }

  &__eyebrow {
    color: inherit;
    display: block;
    margin-bottom: 1.25rem;
    text-decoration: none;
    text-transform: uppercase;
  }

  &__heading:is(h1) {
    margin-bottom: 0.9375rem;

    @include media-query(desktop) {
      margin-bottom: 1.875rem;
    }
  }

  &__subheading {
    max-width: 550px;
    margin: 0 auto;

    @include media-query(desktop) {
      margin-bottom: 1.25rem;
      margin-left: 0;
    }
  }
}
`